import React, { useState, useEffect, useRef } from 'react';
import MainContent from './MainContent';
import PrivateRoute from './PrivateRoute';
import styled from 'styled-components';
import dreilesImage from '../assets/MainPageHeaderImage.png';
import GoldMedalImage from '../assets/medol.png';
import BronzeMedalImage from '../assets/medol_Bronze.png';
import SilverMedalImage from '../assets/medol_Silver.png';
import WinWheelImag from '../assets/winwheel.png';
import { IoMenu } from "react-icons/io5";
import { getUserProfile } from '../utils/userProfile';
import { Avatar } from '@mui/material';
import Backdrop from '@mui/material/Backdrop';
import { CircularProgress } from '@mui/material';
import axios from 'axios';
import MaterialNotifyComponent from './MaterialNotifyComponent';
import { deleteAuthenticationToken, getAuthenticationToken ,IsAuthenticated} from '../utils/TokenHandler'
import { setUserProfile } from '../utils/userProfile';
import Box from '@mui/material/Box';
import { Redirect, withRouter } from 'react-router-dom'

const MainContainer = styled.div`
    margin: 0;
    text-align: center;
    background-color: #004f9e;
    color: white;
    width: 100%;
`;
const HeaderFirstLine = styled.div`height: 20px;display: flex; background: #ffffff;`;
const HeaderBorder = styled.div`height: 2px;background:#231f20;display: flex;`;
const HeaderSection = styled.div`height: 150px; background-image: linear-gradient(180deg, #0168b5 0%, #009bde 50%, #0168b5 100%);`;
const HeaderText = styled.div`position: absolute;right: 25px;margin-top: 15px; display: inline-block;line-height: 1.4;`;
const HeaderTextDivder = styled.div`height: 2px;background:rgba(255,255,255,0.6);margin-top: 3px;`;
const MedalText = styled.div`position: absolute;left: 35px;margin-top: -18px; display: inline-block;font-weight: bold;font-size: x-small;color:rgba(255,255,255,0.6);`;
const HeaderPointAndMenuBox = styled.div`height: 30px;display: flex; background: #f7fbfe;`;
const SideMenuContainer = styled.div`height: 60vh;display: flex;background: #ffffff;`;
const SideMenu = styled.div`            
    position: absolute;
    right: 0px;
    top: 174px;
    width: 280px;
    background-image: linear-gradient(135deg, #231f20 0%, #034ea2 50%, #034ea2 100%);
    box-sizing: border-box;
    z-index: 2;
`;
const SideMenuHeader = styled.div`width: 100%;height: 100px;display: flex;justify-content: space-around;justify-items: center;padding-top: 30px;flex-direction: row-reverse;`;
//const SideMenuProfileIcon = styled.div`width: 70px; height: 70px;background-color: #ffffff; border-radius: 50%;`;
const SideMenuNameAndPoint = styled.div`padding-top: 7px;`;
const SideMenuItem = styled.ul`
    list-style-type: none;
    line-height: 2.0rem;
`;
const SideMenuOddItem = styled.li`background-image: linear-gradient(270deg, #034ea2 0%, #0168b5 100%);cursor: pointer;`;
const SideMenuEvenItem = styled.li`cursor: pointer;`;
const FooterSection = styled.div`position: fixed;width: 100%;left:0px;bottom: 0px;height: 100px;background-image: linear-gradient(180deg, #0168b5 0%, #009bde 50%, #0168b5 100%);`;
const FooterWinWheelImage = styled.img`position: absolute;right: 15px;height: 140px;bottom: 30px;filter: drop-shadow(5px 5px 5px #222);`;
const winwheelCss = `
.winwheel {
    position: absolute;
    top: 10px;
    left: 20px;
    width: 130px;
    height: 33px;
    display: flex;
    justify-content: center;
    align-items: center;
    background: #0184c8;
    box-shadow: -2px -3px 15px 2px rgba(6, 254, 254, 0.7);
    border: rgba(6, 254, 254, 0.6) solid 3px;
    border-radius: 12px;
    padding: 3px;
    letter-spacing: 1px;
    text-decoration: none;
    overflow: hidden;
    color: #fff;
    font-weight: bold;
    z-index: 1;
    cursor: pointer;
}

.winwheel::before {
    content: "";
    position: absolute;
    top: 0;
    left: -35px;
    width: 50%;
    height: 100%;
    background: rgba(6, 254, 254, 0.35);
    transform: skewX(300deg) translate(0);
}
.exitDownCorner {
    margin: -10px 82px 0px 0px;
    width: 90px;
    height: 90px;
    background-color: #2e456e;
    position: relative;
    overflow: hidden;
}

.exitDownCorner::before{
    content: '';
    position: absolute;
    width: 200%;
    height: 200%;
    background-color: #034ea2 ;
    border-radius: 0 0 100% 0;
    top: -100%;
    left:-20%;
}  
.exitTopCorner {
    margin-top: -120px;
    width: 40px;
    height: 50px;
    background-color: #2e456e;
    position: relative;
    overflow: hidden;
}

.exitTopCorner::before{
    content: '';
    position: absolute;
    width: 200%;
    height: 200%;
    background-color: #034ea2 ;
    border-radius: 0 0 100% 0;
    top: -100%;
    left:-20%;
}  
    
.linkForOut {
  text-decoration: none; /* حذف زیر خط */
  color: #ffffff; /* رنگ لینک در حالت عادی */
}

.linkForOut:visited {
  color: #ffffff; /* رنگ لینک بعد از کلیک */
}

.linkForOut:hover {
  color: #ffffff; /* رنگ لینک هنگام هاور */
}

.linkForOut:active {
  color: #ffffff; /* رنگ لینک هنگام کلیک */
}
`;
const FooterText = styled.div`position: absolute; bottom: 0px; width: 100%;text-align: center; direction: rtl;`;
const ExitButton = styled.div`      
    position: absolute;
    bottom: 0px;
    right: 0;
    width: 60px;
    height: 40px;
    border-radius: 100% 0 0 0;
    background-color: #2e456e;
    color: #ff8e8d;
    padding: 50px 0px 0px 30px;
`;
const CardContainer = styled.div`background:#ffffff;height:90%;`;
const MainCards = styled.div`
    display: flex;
    flex-wrap: wrap;
    justify-content: space-evenly;
    background: #ffffff;
`;
const Card = styled.div`
    margin: 10px 0px;
    height: 100px;
    width: 100px;
    background-color: #ffffff;
    border: 3px solid #034ea2;
    border-radius: 15px;
    color: #231f20;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor:pointer;
`;

const userProfile = getUserProfile();

const Dashboard = (props) => {
    const { history } = props
    const [isSideMenuOpen, setIsSideMenuOpen] = useState(false);
    const [dashboardData, setDashboardData] = useState(null);
    const [messageNotify, setMessageNotify] = useState({ severity: "warning", message: "", open: false });
    const [open, setOpen] = useState(true);
    const wrapperRef = useRef(null);

    const handleClickOutside = (event) => {
        if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
            setIsSideMenuOpen(false);
        }
    };

    const getPoints = (isForMerchant) => {
        let sumPoint = 0;
        try {
            dashboardData.pointViewModel.filter((x) => x.isForMerchant === isForMerchant).forEach(item => sumPoint += item.totalPoint);
        } catch { }
        return sumPoint;
    };
    const userId = getAuthenticationToken()?.userID;
    let isAdminUser = <></>;
    if (userId != null) {
        isAdminUser = (userId == 2214 || userId == 10) ?
            <SideMenuOddItem onClick={() => { history.push('/checkSerialNumber') }}>
                چک کردن سریال
            </SideMenuOddItem> :
            <></>
    }

    useEffect(() => {
        if (!IsAuthenticated())
            return (
                <Redirect to="/loginbymobile" />
            )
        document.addEventListener("mousedown", handleClickOutside);
        axios.get('api/v2/Dashboard/GetDashboardNew', {
            params:
            {
                userId: getAuthenticationToken().userID
            }
        }).then((response) => {
            setDashboardData(response.data);
            setUserProfile({
                customerUserName: response.data.customerUserName,
                customerName: response.data.customerName,
                profileCDNImage: response.data.profileCDNImage,
                customerType: response.data.customerType
            });
        }).catch((e) => {
            setMessageNotify({
                severity: "error",
                message: "خطا در فراخوانی اطلاعات از سرور",
                open: true
            });
        }).finally(() => {
            setOpen(false);
        })
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);
    if (dashboardData !== null) {
        return (
            <>
                <PrivateRoute>
                    <style>{winwheelCss}</style>
                    <MainContainer>
                        <HeaderFirstLine />
                        <HeaderBorder />
                        <HeaderSection>
                            <HeaderText>
                                گارانتی 24 ماهه
                                <HeaderTextDivder />
                                اِن ای سی
                            </HeaderText>
                            <img src={dreilesImage} style={{ position: 'absolute', right: '5px', margin: '60px 60px 0 0', width: '180px' }} />
                            <img src={dashboardData.customerRank.name === 'برنزی' ? BronzeMedalImage : (dashboardData.customerRank.name === 'نقره ای' ? SilverMedalImage : GoldMedalImage)} style={{ position: 'absolute', left: '5px', height: '190px', filter: 'drop-shadow(5px 5px 5px #222)' }} />
                        </HeaderSection>
                        <MedalText>
                            سطح<br />
                            {dashboardData.customerRank.name}
                        </MedalText>
                        <HeaderBorder />
                        <HeaderPointAndMenuBox>
                            <div style={{ cursor: 'pointer' }} onClick={() => setIsSideMenuOpen(true)}>
                                <IoMenu style={{ color: '#000000', fontSize: '1.9rem' }} />
                            </div>
                            <Box sx={{ paddingLeft: { xs: '20%', sm: '15%', md: '0px', lg: '0px', xl: '0px' } }}
                                style={{ color: '#414042', margin: 'auto', fontSize: 'smaller' }}
                            >امتیازات <span style={{ fontSize: 'large' }}>{getPoints(false)}</span></Box>
                        </HeaderPointAndMenuBox>
                        <CardContainer>
                            <MainCards>
                                <Card onClick={() => { history.push('/customeraddtoolsserial') }}>ثبت سریال محصول</Card>
                                <Card onClick={() => { history.push('/customerrepresenteradd') }}>ثبت معرف</Card>
                            </MainCards>
                            <MainCards>
                                <Card onClick={() => { history.push('/supportsystemticketing') }} style={{ position: 'relative' }}>
                                    <div style={{
                                        position: 'absolute',
                                        top: '-15px',
                                        right: '-15px',
                                        width: '30px',
                                        height: '30px',
                                        backgroundColor: 'red',
                                        color: 'white',
                                        display: 'flex',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        borderRadius: '50%',
                                        fontSize: '14px'
                                    }}>0</div>
                                    پیام های دریافتی
                                </Card>
                                <Card onClick={() => { history.push('/lotteries') }}>قرعه کشی</Card>
                            </MainCards>
                        </CardContainer>
                        <SideMenu style={{ display: isSideMenuOpen ? '' : 'none', minHeight: (window.innerHeight - 234) + 'px' }} ref={wrapperRef}>
                            <SideMenuHeader>
                                <SideMenuNameAndPoint>
                                    <div>{userProfile.customerName}</div>
                                    <div>امتیاز ---- {getPoints(false)}</div>
                                </SideMenuNameAndPoint>
                                <Avatar style={{ height: '4rem', width: '4rem', background: '#ffffff' }}
                                    src={userProfile.profileCDNImage} />
                            </SideMenuHeader>
                            <div>
                                <SideMenuItem className='menuList'>
                                    <SideMenuOddItem onClick={() => { history.push('/userprofile') }}>پروفایل</SideMenuOddItem>
                                    <SideMenuEvenItem onClick={(e) => { history.push('/') }}>داشبورد</SideMenuEvenItem>
                                    <SideMenuOddItem onClick={() => { history.push('/scoredetail') }}>امتیازات</SideMenuOddItem>
                                    <SideMenuEvenItem onClick={() => { history.push('/lotteries') }}>قرعه کشی</SideMenuEvenItem>
                                    <SideMenuOddItem onClick={() => { history.push('/customerrepresenter') }}>معرفی دوستان</SideMenuOddItem>
                                    <SideMenuEvenItem onClick={() => { history.push('/customerrepresenteradd') }}>ثبت معرف</SideMenuEvenItem>
                                    <SideMenuOddItem onClick={() => { history.push('/customeraddtoolsserial') }}>ثبت کد محصول</SideMenuOddItem>
                                    <SideMenuEvenItem onClick={() => { history.push('/supportsystemticketing') }}>پیام ها</SideMenuEvenItem>
                                    <SideMenuOddItem onClick={() => { history.push('/changepassword') }}>تغییر کلمه عبور</SideMenuOddItem>
                                    <SideMenuEvenItem>
                                        <a className='linkForOut' href="https://nectools.ir/%D9%86%D9%85%D8%A7%DB%8C%D9%86%D8%AF%DA%AF%DB%8C-%D9%87%D8%A7%DB%8C-%D8%AE%D8%AF%D9%85%D8%A7%D8%AA/" target="_blank" rel="noopener noreferrer">
                                            لیست نمایندگی ها
                                        </a>
                                    </SideMenuEvenItem>
                                    {isAdminUser}
                                </SideMenuItem>
                            </div>
                            <div style={{ width: '100%', height: '130px' }}></div>
                            <div>
                                <ExitButton>
                                    <span onClick={() => {
                                        deleteAuthenticationToken();
                                        history.push('/loginbymobile');
                                    }} style={{ fontSize: 'large', cursor: 'pointer' }}>خروج</span>
                                    <div className='exitTopCorner'></div>
                                    <div className='exitDownCorner'></div>
                                </ExitButton>
                                <div style={{ position: 'absolute', bottom: '0px', left: '0px', width: '100%', height: '5px', backgroundColor: '#2e456e' }}></div>
                            </div>
                        </SideMenu>
                        {/* <MainContent /> */}
                        <FooterSection>
                            <FooterWinWheelImage src={WinWheelImag} />
                            <div onClick={() => { history.push('/wheel') }} className="winwheel"><span style={{ zIndex: '2', fontSize: 'large', cursor: 'pointer' }}>گردونه شانس</span></div>
                            <FooterText>باشگاه مشتریان NEC</FooterText>
                            <div style={{ position: 'absolute', bottom: '0px', left: '0px', fontSize: 'xx-small', margin: '5px 0px 5px 2px' }}>
                                <span></span>
                                <a style={{ color: 'rgba(210,210,210,0.7)', textDecoration: 'none' }} href="https://www.gazh.ir/"> طراحی و اجرا <span style={{ color: 'rgba(210,210,210,1.0)' }}>گاژ</span> </a>
                            </div>
                        </FooterSection>
                    </MainContainer>
                </PrivateRoute>
                <MaterialNotifyComponent onclose={() => { setMessageNotify({ ...messageNotify, open: false }) }} open={messageNotify.open} severity={messageNotify.severity} message={messageNotify.message} />
                <Backdrop
                    sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                    open={open}
                >
                    <CircularProgress color="inherit" />
                </Backdrop>
            </>
        );
    }
    else {
        return (
            <>
                <PrivateRoute>
                    <style>{winwheelCss}</style>
                    <MainContainer>
                        <HeaderFirstLine />
                        <HeaderBorder />
                        <HeaderSection>
                            <HeaderText>
                                گارانتی 24 ماهه
                                <HeaderTextDivder />
                                اِن ای سی
                            </HeaderText>
                            <img src={dreilesImage} style={{ position: 'absolute', right: '5px', margin: '60px 60px 0 0', width: '180px' }} />
                            <img src={BronzeMedalImage} style={{ position: 'absolute', left: '5px', height: '190px', filter: 'drop-shadow(5px 5px 5px #222)' }} />
                        </HeaderSection>
                        <MedalText>
                            سطح<br />برنزی
                        </MedalText>
                        <HeaderBorder />
                        <HeaderPointAndMenuBox>
                            <div style={{ cursor: 'pointer' }} onClick={() => setIsSideMenuOpen(true)}>
                                <IoMenu style={{ color: '#000000', fontSize: '1.9rem' }} />
                            </div>
                        </HeaderPointAndMenuBox>
                        <mainCards />
                        <SideMenu style={{ display: isSideMenuOpen ? '' : 'none', minHeight: (window.innerHeight - 234) + 'px' }} ref={wrapperRef}>
                            <SideMenuHeader>
                                <SideMenuNameAndPoint>
                                    <div>نام و نام خانوادگی</div>
                                    <div>امتیاز ------ 0</div>
                                </SideMenuNameAndPoint>
                                <Avatar style={{ height: '4rem', width: '4rem', background: '#ffffff' }} />
                            </SideMenuHeader>
                            <div>
                                <SideMenuItem className='menuList'>
                                    <SideMenuOddItem onClick={() => { history.push('/userprofile') }}>پروفایل</SideMenuOddItem>
                                    <SideMenuEvenItem onClick={(e) => { history.push('/') }}>داشبورد</SideMenuEvenItem>
                                    <SideMenuOddItem onClick={() => { history.push('/scoredetail') }}>امتیازات</SideMenuOddItem>
                                    <SideMenuEvenItem onClick={() => { history.push('/lotteries') }}>قرعه کشی</SideMenuEvenItem>
                                    <SideMenuOddItem onClick={() => { history.push('/customerrepresenter') }}>معرفی دوستان</SideMenuOddItem>
                                    <SideMenuEvenItem onClick={() => { history.push('/customerrepresenteradd') }}>ثبت معرف</SideMenuEvenItem>
                                    <SideMenuOddItem onClick={() => { history.push('/customeraddtoolsserial') }}>ثبت کد محصول</SideMenuOddItem>
                                    <SideMenuEvenItem onClick={() => { history.push('/supportsystemticketing') }}>پیام ها</SideMenuEvenItem>
                                    <SideMenuOddItem onClick={() => { history.push('/changepassword') }}>تغییر پسورد</SideMenuOddItem>
                                    {isAdminUser}
                                </SideMenuItem>
                            </div>
                            <ExitButton>
                                <span onClick={() => {
                                    deleteAuthenticationToken();
                                    history.push('/loginbymobile');
                                }} style={{ fontSize: 'large', cursor: 'pointer' }}>خروج</span>
                                <div className='exitTopCorner'></div>
                                <div className='exitDownCorner'></div>
                                <div style={{ width: '200PX', height: '5px', position: 'relative', bottom: '5px', backgroundColor: '#2e456e', marginRight: '80px' }}></div>
                            </ExitButton>
                        </SideMenu>
                        <FooterSection>
                            <FooterWinWheelImage src={WinWheelImag} />
                            <div onClick={() => { history.push('/wheel') }} className="winwheel"><span style={{ zIndex: '2', fontSize: 'large', cursor: 'pointer' }}>گردونه شانس</span></div>
                            <FooterText>باشگاه مشتریان NEC</FooterText>
                            <div style={{ position: 'absolute', bottom: '0px', left: '0px', fontSize: 'xx-small', margin: '5px 0px 5px 2px' }}>
                                <span></span>
                                <a style={{ color: 'rgba(210,210,210,0.7)', textDecoration: 'none' }} href="https://www.gazh.ir/"> طراحی و اجرا گسترش ارتباطات ژرف</a>
                            </div>
                        </FooterSection>
                    </MainContainer>
                </PrivateRoute>
                <MaterialNotifyComponent onclose={() => { setMessageNotify({ ...messageNotify, open: false }) }} open={messageNotify.open} severity={messageNotify.severity} message={messageNotify.message} />
                <Backdrop
                    sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                    open={open}
                >
                    <CircularProgress color="inherit" />
                </Backdrop>
            </>
        );
    }
    document.removeEventListener("mousedown", handleClickOutside);
};

export default Dashboard;
